import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="table-header-subtitle">
                    <b>{t('search.keyword_clusters.gsc_clustering_description.bold')}</b>{' '}
                    {t('search.keyword_clusters.gsc_clustering_description.text')}
                </div>
            </>
        );
    }
}

export default ExtraButtons;
